export default __webpack_public_path__ + "static/media/ID_NEWYORK_MICHAEL COLLINS.8c994757.jpg";